<template>
  <v-layout row wrap>
    <v-flex xs12 style="display: flex; flex-direction: column">
      <v-card v-if="modifiedSendMailConfig" class="pa-2" style="flex: 1 1 auto; display: flex; flex-direction: column">
        <v-card-title
          class="pb-0"
          style="flex: 1 1 auto; flex-direction: column; align-items: stretch; position: relative"
        >
          <span class="subheading mb-1" style="flex: 0 0 auto">{{ $t('Pilot.SendMail.Configuration') }}</span>
          <v-switch
            hide-details
            class="pb-2 sm-switch"
            v-model="config.enableSendMail"
            @change="saveConfig"
            :label="$t('Pilot.SendMail.EnableSendMail')"
            style="flex: 0 0 auto"
          />
          <v-text-field
            @keydown.stop.enter="addNewMailGlider()"
            :disabled="!config.enableSendMail"
            :label="$t('Pilot.SendMail.GliderAlarm')"
            v-model="new_mails_glider_alr"
            style="flex: 0 0 auto"
            append-outer-icon="mdi-plus"
            @click:append-outer="addNewMailGlider()"
          />
          <div class="pb-2" style="border-bottom: 1px dashed #000">
            <v-chip
              v-for="mail in config.SendMail_mailling.mails_glider_alr"
              :key="mail"
              close
              @input="removeGliderMail(mail)"
            >
              {{ mail }}
            </v-chip>
          </div>
          <!--
          <v-text-field @keydown.stop.enter="addNewMailIris()" :disabled="!config.enableSendMail" :label="$t('Pilot.SendMail.IrisAlarm')" v-model="new_mails_iris_alr" style="flex:0 0 auto" append-outer-icon="mdi-plus" @click:append-outer="addNewMailIris()" />                    
          <div class="pb-2" style="border-bottom:1px dashed #000">
            <v-chip v-for="mail in config.SendMail_mailling.mails_iris_alr" :key="mail" close @input="removeIrisMail(mail)">{{mail}}</v-chip>
          </div>-->
          <v-text-field
            @keydown.stop.enter="addNewMailSurfacing()"
            :disabled="!config.enableSendMail"
            :label="$t('Pilot.SendMail.SurfacingAlarm')"
            v-model="new_mails_surfacing"
            style="flex: 0 0 auto"
            append-outer-icon="mdi-plus"
            @click:append-outer="addNewMailSurfacing()"
          />
          <div class="pb-2" style="border-bottom: 1px dashed #000">
            <v-chip
              v-for="mail in config.SendMail_mailling.mails_surfacing"
              :key="mail"
              close
              @input="removeSurfacingMail(mail)"
            >
              {{ mail }}
            </v-chip>
          </div>
          <template v-if="showDetection">
            <v-text-field
              @keydown.stop.enter="addNewMailDetection()"
              :disabled="!config.enableSendMail"
              :label="$t('Pilot.SendMail.DetectionAlarm')"
              v-model="new_mails_detection"
              style="flex: 0 0 auto"
              append-outer-icon="mdi-plus"
              @click:append-outer="addNewMailDetection()"
            />
            <div>
              <v-chip
                v-for="mail in config.SendMail_mailling.mails_detection"
                :key="mail"
                close
                @input="removeDetectionMail(mail)"
              >
                {{ mail }}
              </v-chip>
            </div>
          </template>
        </v-card-title>
        <v-card-actions class="pr-3">
          <v-spacer />
          <!--<v-btn @click.prevent="resetConfig" small >{{$t('Pilot.FileTransfert.ResetConfig')}}<v-icon small right>mdi-backup-restore</v-icon></v-btn>-->
          <v-btn @click.prevent="restoreConfig" :disabled="!btnActif" small>
            {{ $t('Pilot.SendMail.RestoreConfig') }}
            <v-icon small right>mdi-replay</v-icon>
          </v-btn>
          <v-btn @click.prevent="saveConfig" :disabled="!btnActif" small color="primary">
            {{ $t('Pilot.SendMail.ValidateConfig') }}
            <v-icon small right>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      <v-card v-else class="pa-2" style="flex: 1 1 auto; display: flex; flex-direction: column">
        <v-card-title
          class="pb-0"
          style="flex: 1 1 auto; flex-direction: column; align-items: start; position: relative"
        >
          <span>{{ $t('Pilot.SendMail.NoDataAvailable') }}</span>
        </v-card-title>
      </v-card>
    </v-flex>
    <!-- Dialog de chargement... -->
    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ status }}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script setup lang="ts">
import { ref, computed, watch, getCurrentInstance } from 'vue'
import deepEqual from 'deep-equal'
import { MissionUi } from '@/models/ui/MissionUi'
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer'
import { ISendMailConfig } from '@/models/iris/sendMail/ISendMailConfig'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { AloMission } from '@/models/alo/AloMission'
import store from '@/store'
import { i18n } from '@/locale/vueI18n'

const props = defineProps<{
  mission: AloMission
}>()
// Accès aux plugins Vue via l'instance (Vue 2 + Composition API)
const instance = getCurrentInstance()
const $confirm = instance?.proxy?.$confirm!

const new_mails_glider_alr = ref('')
const new_mails_iris_alr = ref('')
const new_mails_surfacing = ref('')
const new_mails_detection = ref('')

const config = ref({
  enableSendMail: true,
  SendMail_mailling: {
    mails_glider_alr: [] as string[],
    mails_iris_alr: [] as string[],
    mails_surfacing: [] as string[],
    mails_detection: [] as string[],
  },
})

const nextSurfacingCmd = ref('')
const allSurfacingCmd = ref('')

const showDetection = computed(() => store.myGetters.userProfile?.config?.postprocess_image ?? false)

const loading = computed(() => store.myGetters.sendMailLoading)
const status = computed(() => store.myGetters.gliderStatus)
const originalSendMailConfig = computed(() => store.myGetters.originalSendMailConfigs[props.mission.misId!])
const modifiedSendMailConfig = computed(() => store.myGetters.modifiedSendMailConfigs[props.mission.misId!])

const btnActif = computed(() => {
  const configCopy = {
    SendMail_mailling: {
      mails_glider_alr: [] as string[],
      mails_iris_alr: [] as string[],
      mails_surfacing: [] as string[],
      mails_detection: [] as string[],
    },
  }
  loadConfig(configCopy, originalSendMailConfig.value)
  return !deepEqual(configCopy, config.value) && !loading.value
})

function removeMail(mail: string, mails: string[]) {
  const idx = mails.indexOf(mail)
  if (idx > -1) {
    $confirm(i18n.t('Pilot.SendMail.DeleteMailDialogMessage').toString(), {
      title: i18n.t('Admin.Warning'),
    } as VuetifyConfirmObject).then((answer: boolean | undefined) => {
      if (answer) mails.splice(idx, 1)
    })
  }
}

function addMail(mail: string, mails: string[]) {
  if (mail.length > 0) {
    if (mails.indexOf(mail) == -1) {
      mails.push(mail)
    }
  }
}

function addNewMailGlider() {
  addMail(new_mails_glider_alr.value, config.value.SendMail_mailling.mails_glider_alr)
  new_mails_glider_alr.value = ''
}

function removeGliderMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_glider_alr)
}

function addNewMailIris() {
  addMail(new_mails_iris_alr.value, config.value.SendMail_mailling.mails_iris_alr)
  new_mails_iris_alr.value = ''
}

function removeIrisMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_iris_alr)
}

function addNewMailSurfacing() {
  addMail(new_mails_surfacing.value, config.value.SendMail_mailling.mails_surfacing)
  new_mails_surfacing.value = ''
}

function removeSurfacingMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_surfacing)
}

function addNewMailDetection() {
  addMail(new_mails_detection.value, config.value.SendMail_mailling.mails_detection)
  new_mails_detection.value = ''
}

function removeDetectionMail(mail: string) {
  removeMail(mail, config.value.SendMail_mailling.mails_detection)
}

function loadConfig(target: any, configData: IrisConfigContainer<ISendMailConfig>) {
  if (configData) {
    target.enableSendMail = configData.mod_settings.EnabledMOD['module-SendMail']
    target.SendMail_mailling = {
      ...target.SendMail_mailling,
      ...configData.mod_settings.SendMail_mailling,
    }
  }
}

function validateConfig() {
  store.myActions.MISSION_UPDATE_MODIFIED_SEND_MAIL({
    itemId: props.mission.misId!,
    newProperties: {
      mod_settings: {
        EnabledMOD: {
          'module-SendMail': config.value.enableSendMail,
        },
        SendMail_mailling: {
          ...config.value.SendMail_mailling,
        },
      },
    },
  })
}

function saveConfig() {
  validateConfig()
  store.myActions.MISSION_IRIS_SEND_MAIL_SAVE_REQUEST(props.mission.misId!)
}

function restoreConfig() {
  store.myActions.MISSION_CANCEL_MODIFIED_SEND_MAIL(props.mission.misId!)
}

// Watch for mission changes
watch(
  () => props.mission,
  newValue => {
    if (newValue.misId != null) {
      store.myActions.MISSION_IRIS_SEND_MAIL_REQUEST(newValue.misId)
    }
  },
)

// Watch for modifiedSendMailConfig changes
watch(modifiedSendMailConfig, (newConfig: IrisConfigContainer<ISendMailConfig>) => {
  loadConfig(config.value, newConfig)
})

// Watch for config changes
watch(
  config,
  () => {
    validateConfig()
  },
  { deep: true },
)

// Created lifecycle
if (props.mission.misId != null) {
  store.myActions.MISSION_IRIS_SEND_MAIL_REQUEST(props.mission.misId!).then(() => {
    loadConfig(config.value, modifiedSendMailConfig.value)
  })
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.subheading,
.body-2 {
  font-weight: bold;
}

.btnup {
  position: absolute;
  top: -6px;
  right: -7px;
}
.btnup:hover {
  position: absolute;
}
.btndown {
  position: absolute;
  bottom: -6px;
  right: -7px;
}
.btndown:hover {
  position: absolute;
}

.flex-container {
  display: flex;
  flex-direction: column;
  position: relative;
}

.position {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 31px;
  background-color: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.disable {
  overflow: hidden !important;
  position: relative;
}

.disable::before {
  position: absolute;
  content: '';
  left: 0px;
  right: 0px;
  top: 0px;
  height: 8000%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
</style>
